import React from "react";
import "./Bannersecstion.css";
import bannerImg from "../../../assets/images/girl.webp";

const BannerSection = () => {
  return (
    <section className="vx-banner-section">
      <div
        className="vx-banner"
        style={{ backgroundImage: `url(${bannerImg})` }}
      >
        <div className="vx-banner-overlay">
          <h1>Welcome HRM Admin</h1>
          <p>Control Employees, Payroll & Performance</p>
        </div>
      </div>
    </section>
  );
};

export default BannerSection;
